import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import useAPIError from '../../../hooks/useAPIError';
import { DirectionData, TiposVia } from '../../../types/PersonalData';
import { MisDatosHelper } from '../MisDatosHelper';
import { MisDatosConstants } from '../../../utils/MisDatosConstants';
import DataService from '../../../services/MisDatosService';
import IconChat from '../../../Icons/IconChat';
import { CryptoUtil } from '../../../utils/CryptoUtil';

interface Props {
  directionData: DirectionData;
  tempDirectionData: DirectionData;
  isParticular: boolean;
  setTempDirectiondata: any;
  updateDireccion: () => void;
  handleChange: (key: string, e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeSelect: (
    key: string,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  tiposVia: TiposVia[];
  manageProvinceByCP: (postalCode: string, id: string) => void;
  isAdd: boolean;
}

const FacturacionEmpresaForm: FC<Props> = (props) => {
  const {
    directionData,
    tempDirectionData,
    isParticular,
    setTempDirectiondata,
    updateDireccion,
    handleChange,
    handleChangeSelect,
    tiposVia,
    manageProvinceByCP,
    isAdd,
  } = props;
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm({
    mode: 'onChange',
  });
  const { addError, addWarning } = useAPIError();
  const misDatosHelper = new MisDatosHelper();

  const [visible, setVisible] = useState<boolean>(false);

  const validarTipoVia = (value: any) => {
    return value !== '0';
  };

  const validarTipoDni = (currentvalue: any) => {
    const tipoDoc = MisDatosConstants.TIPO_DOC_CIF;
    let values = currentvalue;
    const elements = document.getElementsByName('cif');
    values =
      elements.length > 0
        ? (elements[elements.length - 1] as HTMLInputElement).value
        : null;
    return misDatosHelper.validarTipoDni(values, tipoDoc);
  };

  const recortarRazonSocial = (razonSocial: string) => {
    const razonSocialRaw = razonSocial;
    let razonSocialRecortado = razonSocial;
    if (
      razonSocialRaw.length > MisDatosConstants.MAX_LENGTH_RAZON_SOCIAL_DIR_FAC
    ) {
      razonSocialRecortado = razonSocialRaw.substr(
        0,
        MisDatosConstants.MAX_LENGTH_RAZON_SOCIAL_DIR_FAC - 1,
      );
    }
    return razonSocialRecortado;
  };

  const manageRazonSocialByCif = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string,
  ) => {
    const data = {
      cif: btoa(CryptoUtil.encryptAes(e.target.value)),
    };
    const razonSocialInput = document.getElementById(id) as HTMLInputElement;
    if (e.target.value !== null && e.target.value.length !== 0) {
      DataService.getRazonSocialByCif(data)
        .then((response) => {
          if (response.data.error === true) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
          } else {
            // eslint-disable-next-line no-lonely-if
            if (response.data.pojo.razonSocialEncontrada) {
              response.data.pojo.razonSocial = CryptoUtil.decryptAes(
                response.data.pojo.razonSocial,
              );
              const razonSocialRecortado = recortarRazonSocial(
                response.data.pojo.razonSocial,
              );
              if (razonSocialInput) {
                razonSocialInput.value = razonSocialRecortado;
              }
              setTempDirectiondata({
                ...tempDirectionData,
                razonSocial: razonSocialRecortado,
              });
              trigger('razon');
            } else {
              addWarning(t('validaciones.not-correct-cif-for-razonSocial'));
            }
          }
        })
        .catch((er: any) => {
          console.log(er);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    } else {
      if (razonSocialInput) {
        razonSocialInput.value = '';
      }
      setTempDirectiondata({
        ...tempDirectionData,
        razonSocial: '',
      });
      trigger('razon');
    }
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      const element = document.getElementById('form-empresa') as HTMLElement;
      console.log('🚀 ---------------------------------🚀');
      console.log('🚀 ~ saveInfo ~ element:', element);
      console.log('🚀 ---------------------------------🚀');

      const buttonElement = document.getElementById(
        `fact-empresa-${directionData.idDireccion}-btn`,
      );
      if (buttonElement) {
        buttonElement.click();
        setVisible(false);
      }
    }
  };
  useEffect(() => {
    console.log('🚀 ----------------------------------🚀');
    console.log('🚀 ~ useEffect ~ visible:', visible);
    console.log('🚀 ----------------------------------🚀');
    if (visible) {
      const element = document.getElementById('form-empresa') as HTMLElement;
      if (element.classList.contains('visible')) {
        element.setAttribute('tabindex', '0');
        element.focus();
        element.addEventListener('keydown', saveInfo, false);
      } else {
        element.removeEventListener('keydown', saveInfo, false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    const sectionElement = document.querySelector(
      'section.o-section--large.form-facturacion.bloque-form',
    );
    if (sectionElement && sectionElement.classList.contains('visible')) {
      setVisible(true);
    }
  }, []);

  return (
    <>
      <div className="container">
        <form
          id="form-empresa"
          className={`form-edit-facturacion ${!isParticular ? 'visible' : ''}`}
          noValidate
          onSubmit={handleSubmit(updateDireccion)}
        >
          <div className="row u-margin-bottom">
            <div className="col-12 col-md-4">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="cif" className="control-label">
                  {t('datos.directions.cif')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className={`form-control ${errors.cif ? 'error' : ''}`}
                    id={`cif-${directionData.idDireccion}`}
                    maxLength={MisDatosConstants.MAX_LENGTH_DIR_FAC_CIF}
                    defaultValue={directionData.cif}
                    {...register('cif', {
                      required: true,
                      validate: (value) => validarTipoDni(value),
                      onChange(event) {
                        handleChange('cif', event);
                      },
                    })}
                    onBlur={(e) => {
                      manageRazonSocialByCif(
                        e,
                        `razon-${directionData.idDireccion}`,
                      );
                    }}
                  />
                  {errors.cif && errors.cif.type === 'required' && (
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label id="cif-error" className="error" htmlFor="cif">
                      {t('validaciones.empty-value')}
                    </label>
                  )}
                  {errors.cif && errors.cif.type === 'validate' && (
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label id="cif-error" className="error" htmlFor="cif">
                      {t('validaciones.not-valid-format')}
                    </label>
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group select-wrapper u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="control-label" htmlFor="razon">
                  {t('datos.directions.razonSocial')}
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.razon ? 'error' : ''}`}
                  id={`razon-${directionData.idDireccion}`}
                  maxLength={MisDatosConstants.MAX_LENGTH_RAZON_SOCIAL_DIR_FAC}
                  defaultValue={directionData.razonSocial}
                  required
                  readOnly
                  style={{
                    backgroundColor: '#dadada',
                    opacity: 1,
                    color: '#6e6e6e',
                    cursor: 'default',
                  }}
                  {...register('razonSocial', {
                    required: true,
                    onChange: (e) => handleChange('razonSocial', e),
                  })}
                />
                {errors.razon && errors.razon.type === 'required' && (
                  // eslint-disable-next-line jsx-a11y/label-has-associated-control
                  <label id="razon-error" className="error" htmlFor="razon">
                    {t('validaciones.empty-value')}
                  </label>
                )}
              </div>
            </div>
          </div>
          <div className="row u-margin-bottom">
            <div className="col-12 col-md-3">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="codEmpresaFactu" className="control-label">
                  {t('datos.directions.postalCode')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className={`form-control ${
                      errors.codEmpresaFactu ? 'error' : ''
                    }`}
                    id={`cod-empresa-factu-${directionData.idDireccion}`}
                    maxLength={MisDatosConstants.MAX_LENGTH_COD_POSTAL_DIR_FAC}
                    defaultValue={directionData.postalCode}
                    {...register('codEmpresaFactu', {
                      required: true,
                      pattern: /^(?:0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-2])([0-9]{3})$/i,
                      onChange(event) {
                        handleChange('postalCode', event);
                        manageProvinceByCP(
                          event.target.value,
                          `provincia-factu-empresa-${directionData.idDireccion}`,
                        );
                      },
                    })}
                  />
                  {errors.codEmpresaFactu &&
                    errors.codEmpresaFactu.type === 'required' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="codEmpresaFactu-error"
                        className="error"
                        htmlFor="codEmpresaFactu"
                      >
                        {t('validaciones.empty-value')}
                      </label>
                    )}
                  {errors.codEmpresaFactu &&
                    errors.codEmpresaFactu.type === 'pattern' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="codEmpresaFactu-error"
                        className="error"
                        htmlFor="codEmpresaFactu"
                      >
                        {t('validaciones.not-valid-postalCode-spain')}
                      </label>
                    )}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="form-group select-wrapper u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="control-label" htmlFor="local-factu-empresa">
                  {t('datos.directions.locality')}
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    errors.localFactuEmpresa ? 'error' : ''
                  }`}
                  id={`local-factu-empresa-${directionData.idDireccion}`}
                  maxLength={MisDatosConstants.MAX_LENGTH_LOCALIDAD_DIR_FAC}
                  defaultValue={directionData.locality}
                  {...register('localFactuEmpresa', {
                    required: true,
                    onChange(event) {
                      handleChange('localidad', event);
                    },
                  })}
                />
                {errors.localFactuEmpresa &&
                  errors.localFactuEmpresa.type === 'required' && (
                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                    <label
                      id="localFactuEmpresa-error"
                      className="error"
                      htmlFor="localFactuEmpresa"
                    >
                      {t('validaciones.empty-value')}
                    </label>
                  )}
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="form-group select-wrapper u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="control-label" htmlFor="tipo-via-factu">
                  {t('datos.directions.roadType')}
                </label>
                <div className="form-control-block">
                  <select
                    className={`form-control valid ${
                      errors.tipoViaFactu ? 'error' : ''
                    }`}
                    id={`tipo-via-factu-${directionData.idDireccion}`}
                    {...register('tipoViaFactu', {
                      validate: (value) => validarTipoVia(value),
                      onChange(event) {
                        handleChangeSelect('tipoVia', event);
                      },
                    })}
                  >
                    <option value={0}>{t('datos.directions.roadType')}</option>
                    {tiposVia.map((via) => (
                      <option
                        key={via.idTipoVia}
                        selected={via.idTipoVia === directionData.roadType}
                        value={via.idTipoVia}
                      >
                        {via.nombreTipoVia}
                      </option>
                    ))}
                  </select>
                  <div className="icon icon-small">
                    <IconChat />
                  </div>
                  {errors.tipoViaFactu &&
                    errors.tipoViaFactu.type === 'validate' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="tipoViaFactu-error"
                        className="error"
                        htmlFor="tipoViaFactu"
                      >
                        {t('validaciones.empty-value')}
                      </label>
                    )}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="via-factu-empresa" className="control-label">
                  {t('datos.directions.roadName')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className={`form-control ${
                      errors.viaFactuEmpresa ? 'error' : ''
                    }`}
                    id={`via-factu-empresa-${directionData.idDireccion}`}
                    defaultValue={directionData.roadName}
                    {...register('viaFactuEmpresa', {
                      required: true,
                      maxLength: MisDatosConstants.MAX_LENGTH_NOMBRE_DE_VIA,
                      onChange(event) {
                        handleChange('roadName', event);
                      },
                    })}
                  />
                  {errors.viaFactuEmpresa &&
                    errors.viaFactuEmpresa.type === 'required' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="viaFactuEmpresa-error"
                        className="error"
                        htmlFor="viaFactuEmpresa"
                      >
                        {t('validaciones.empty-value')}
                      </label>
                    )}
                </div>
              </div>
            </div>
            <div className="col-4 col-md-1">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="num-factu-empresa" className="control-label">
                  {t('datos.directions.number')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className={`form-control ${
                      errors.numFactuEmpresa ? 'error' : ''
                    }`}
                    maxLength={MisDatosConstants.MAX_LENGTH_NUMERO}
                    id={`num-factu-empresa-${directionData.idDireccion}`}
                    defaultValue={directionData.number}
                    {...register('numFactuEmpresa', {
                      required: true,
                      pattern: /^[0-9]+$/i,
                      onChange(event) {
                        handleChange('number', event);
                      },
                    })}
                  />
                  {errors.numFactuEmpresa &&
                    errors.numFactuEmpresa.type === 'required' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="numFactuEmpresa-error"
                        className="error"
                        htmlFor="numFactuEmpresa"
                      >
                        {t('validaciones.empty-value')}
                      </label>
                    )}
                  {errors.numFactuEmpresa &&
                    errors.numFactuEmpresa.type === 'pattern' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="numFactuEmpresa-error"
                        className="error"
                        htmlFor="numFactuEmpresa"
                      >
                        {t('validaciones.not-valid-value')}
                      </label>
                    )}
                </div>
              </div>
            </div>
            <div className="col-4 col-md-1">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="portal-factu-empresa" className="control-label">
                  {t('datos.directions.portal')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className="form-control"
                    name="portal-factu-empresa"
                    maxLength={MisDatosConstants.MAX_LENGTH_PORTAL}
                    id={`portal-factu-empresa-${directionData.idDireccion}`}
                    defaultValue={directionData.portal}
                    onChange={(e) => handleChange('portal', e)}
                  />
                </div>
              </div>
            </div>
            <div className="col-4 col-md-1">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label
                  htmlFor="escalera-factu-empresa"
                  className="control-label"
                >
                  {t('datos.directions.stairs')}
                </label>
                <div className="form-control-block" />
                <input
                  type="text"
                  className="form-control"
                  name="escalera-factu-empresa"
                  maxLength={MisDatosConstants.MAX_LENGTH_ESCALERA}
                  id={`escalera-factu-empresa-${directionData.idDireccion}`}
                  defaultValue={directionData.stairs}
                  onChange={(e) => handleChange('stairs', e)}
                />
              </div>
            </div>
            <div className="col-4 col-md-1">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="piso-factu-empresa" className="control-label">
                  {t('datos.directions.floor')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className="form-control"
                    name="piso-factu-empresa"
                    maxLength={MisDatosConstants.MAX_LENGTH_PISO}
                    id={`piso-factu-empresa-${directionData.idDireccion}`}
                    defaultValue={directionData.floor}
                    onChange={(e) => handleChange('floor', e)}
                  />
                </div>
              </div>
            </div>
            <div className="col-4 col-md-1">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="puerta-factu-empresa" className="control-label">
                  {t('datos.directions.door')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className="form-control"
                    name="puerta-factu-empresa"
                    maxLength={MisDatosConstants.MAX_LENGTH_PUERTA}
                    id={`puerta-factu-empresa-${directionData.idDireccion}`}
                    defaultValue={directionData.door}
                    onChange={(e) => handleChange('door', e)}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="form-group select-wrapper u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label
                  className="control-label"
                  htmlFor="provincia-factu-empresa"
                >
                  {t('datos.directions.province')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className="form-control"
                    name="provincia-factu-empresa"
                    id={`provincia-factu-empresa-${directionData.idDireccion}`}
                    maxLength={MisDatosConstants.MAX_LENGTH_PROVINCIA_DIR_FAC}
                    disabled
                    defaultValue={directionData.province}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group select-wrapper u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label className="control-label" htmlFor="country-factu">
                  {t('datos.directions.country')}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id={`country-factu-${directionData.idDireccion}`}
                  disabled
                  value="España"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="form-group u-margin-bottom">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="name-factu-empresa" className="control-label">
                  {t('datos.directions.directionName')}
                </label>
                <div className="form-control-block">
                  <input
                    type="text"
                    className={`form-control ${
                      errors.nameFactuEmpresa ? 'error' : ''
                    }`}
                    id={`name-factu-empresa-${directionData.idDireccion}`}
                    maxLength={MisDatosConstants.MAX_LENGTH_NOMBRE_DIRECCION}
                    defaultValue={directionData.directionName}
                    {...register('nameFactuEmpresa', {
                      required: true,
                      onChange(event) {
                        handleChange('directionName', event);
                      },
                    })}
                  />
                  {errors.nameFactuEmpresa &&
                    errors.nameFactuEmpresa.type === 'required' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="nameFactuEmpresa-error"
                        className="error"
                        htmlFor="nameFactuEmpresa"
                      >
                        {t('validaciones.empty-value')}
                      </label>
                    )}
                </div>
              </div>
            </div>
          </div>
          <div className="u-text-right">
            <button
              id={`fact-empresa-${directionData.idDireccion}-btn`}
              type="submit"
              className="btn btn-primary"
            >
              {isAdd ? t('datos.directions.add') : t('datos.directions.update')}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default FacturacionEmpresaForm;
